import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Solicitud } from 'src/entity/solicitud';
import { environment } from 'src/environments/environment';
import { CustomizationStoreService } from 'src/services/customization.store.service';
import { WebhooksService } from 'src/services/webhooks.service';

@Injectable({
  providedIn: 'root'
})
export class SmsFlowService {
  currentHeight = 0;
  socket = null;
  socketOpened = true;
  public widgetUrl;
  public widgetUrlBoxed;

  public REQUEST;
  public REQUEST_STATUS;
  public REQUEST_ID;
  private readonly _request = new BehaviorSubject<Solicitud>({
    ...new Solicitud(),
    status_code: 'created'
  });
  private readonly _request_status = new BehaviorSubject<string>(null);
  readonly request$ = this._request.asObservable();
  readonly request_status$ = this._request_status.asObservable();

  private requestIDSubject = new BehaviorSubject<string>('');
  requestID$ = this.requestIDSubject.asObservable();

  private loadingSubject = new BehaviorSubject<string | boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(
    public customizationStoreService: CustomizationStoreService,
  ) {}
  // --- Métodos de Actualización (Setters) ---

  setLoading(status: string | boolean) {
    this.loadingSubject.next(status);
  }

  // Nuevo método para actualizar requestID (llamado desde SmsComponent)
  updateRequestID(requestId: string) {
    this.requestIDSubject.next(requestId);
    this.REQUEST_ID = requestId;
  }

  // --- Métodos de Inicialización ---
  setGlobalVariables() {
    this.REQUEST = this._request.value;
    this.REQUEST_STATUS = this.REQUEST.status_code;
    this._request_status.next(this.REQUEST_STATUS);
  }

  setRequest(next: Solicitud) {
    this._request.next({ ...next });
    this.setGlobalVariables();
  }

  patch(partial: Partial<Solicitud>) {
    const current = this._request.value;
    this._request.next({ ...current, ...partial });
    this.setGlobalVariables();
  }

  setRequestStatus(status_code: string) {
    const current = this._request.value;
    this._request.next({ ...current, status_code: status_code });
    this.setGlobalVariables();
  }

  public setSubscriptionOfRequest() {
    const self = this;
    if (this.socket) {
      return;
    }
    let url = "wss://notifications.dev.belender.net";
    if (environment.env == "qa") {
      url = "wss://notifications.qa.belender.net";
    }
    if (environment.env == "pro") {
      url = "wss://notifications.belender.net";
    }
    if (environment.notificationsBaseUrl) {
      url = environment.notificationsBaseUrl;
    }
    this.socket = new WebSocket(
      `${url}?requests_id=${this.REQUEST_ID}&user_id=${this.customizationStoreService.USER_ID}`,
    );

    // Abre la conexión
    this.socket.onopen = function (event) {
      console.log("Conexión establecida");
    };

    // Maneja los mensajes entrantes
    this.socket.onmessage = function (event) {
      var mensaje = event.data;

      let objMessage = JSON.parse(mensaje);

      self.handlePusherNotification(objMessage);
    };

    // Maneja los errores de la conexión
    this.socket.onerror = function (error) {
      console.log("WebSocket Error: " + error);
      console.error(error);
    };

    // Cierra la conexión
    this.socket.onclose = function (event) {
      console.log("Conexión cerrada:", event);
      self.socketOpened = false;
    };
  }

  disconnectWebsocket() {
    console.error('disconnect ws')
    this.socket && this.socket.close();
    this.socket = null;
  }

  handlePusherNotification(d) {
    if(!d) return;
    if (WebhooksService.shouldIgnoreWebhookStatus(d.status_code)) {
      return;
    }
    if (d && d.widget_url) {
      this.widgetUrl = d.widget_url;
    }

    if (d && d.widget_url_boxed) {
      this.widgetUrlBoxed = d.widget_url_boxed;
    }

    this.sendMessageToParent({ type: "websocket", data: d });
    console.warn("message from ws: ", d);
    if (!d.status_code) {
      return;
    }

    const code = d.status_code;

    if (code === "consent_process_completed") {
      this.disconnectWebsocket();
    }

    if (code.startsWith("abandoned") || code.startsWith("failed")) {
      this.disconnectWebsocket();
      this.setRequestStatus(code);
      return;
    }

    // Resto de estados (p. ej. waiting_password, OTP…)
    this.patch({ status_code: code });
  }

  public sendMessageToParent(obj) {

    if(obj && obj.type && obj.type === 'widgetHeight') {
      if(obj.data === this.currentHeight) {
        return;
      } else {
        this.currentHeight = obj.data;
      }
    }
    console.log('Message to parent:', obj);
    window.top.postMessage(obj, "*");
  }
}
